import React from "react";

const FormInitials = React.forwardRef(
  (
    { name, label, labelPosition, className, error, onChange, ...rest },
    ref
  ) => {
    return (
      <div className="mb-3" {...rest}>
        {labelPosition === "top" ? (
          <label
            className={`form-label ${
              error ? "text-danger" : "text-safy-success"
            }`}
            htmlFor={name}
          >
            {label}
          </label>
        ) : null}
        <input
          className={`form-control me-2 ${
            className ? `${className} border-secondary` : "border-secondary"
          }`}
          style={{ width: "100px", display: "inline-block" }}
          {...rest}
          name={name}
          id={name}
          ref={ref}
          onChange={onChange}
        />
        {!labelPosition || labelPosition === "bottom" ? (
          <label
            className={error ? "text-danger" : "text-safy-success"}
            htmlFor={name}
          >
            {label}
          </label>
        ) : null}
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    );
  }
);

export default FormInitials;
